import React, {useMemo} from 'react';
import {Table, Button, Dropdown, Input, Grid, Checkbox, Icon} from 'semantic-ui-react';
import {useTable, usePagination, useFilters} from 'react-table';
import {invoicesPageSizesCustomOrders} from '../../../common/constants/lists';
import {Filter, DefaultColumnFilter} from './modelTasksModalFilters';
// import {concat} from 'lodash';

const ModelTasksTable = ({tableColumns, tableData, tasks, edit}) => {
  const data = useMemo(() => tableData, [tableData]);
  const columns = useMemo(() => tableColumns, []);

  const TablePaginator = ({
    page,
    canPreviousPage,
    pageIndex,
    pageOptions,
    pageSize,
    canNextPage,
    nextPage,
    gotoPage,
    previousPage,
    setPageSize,
  }) => {
    if (page.length) {
      const setPage = (pageIdx) => {
        edit.setCurrentPage(pageIdx);
        gotoPage(pageIdx);
      };
      return (
        <Grid className="pagination">
          <Grid.Row>
            <Grid.Column width={4} textAlign="left">
              <Button
                className="navigation-button"
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
                content="Anterior"
              />
            </Grid.Column>
            <Grid.Column width={4} textAlign="right">
              <span>páginas </span>
              <span>
                <Input
                  className="pages-input"
                  type="number"
                  value={pageIndex + 1}
                  min="1"
                  max={pageOptions.length}
                  onChange={(e, {value}) => {
                    const page = value ? Number(value) - 1 : 0;
                    if (page < 1 || page > pageOptions.length) {
                      e.target.value = 1;
                    }
                    setPage(page);
                  }}
                />
              </span>{' '}
              <span>de {pageOptions.length}</span>
            </Grid.Column>
            <Grid.Column width={4} textAlign="left">
              <Dropdown
                className="page-sizes-selection"
                selection
                upward
                compact
                value={pageSize}
                options={invoicesPageSizesCustomOrders}
                onChange={(e, {value}) => {
                  setPageSize(Number(value));
                }}
              />
              <span> filas</span>
            </Grid.Column>
            <Grid.Column width={4} textAlign="right">
              <Button
                className="navigation-button"
                onClick={() => nextPage()}
                disabled={!canNextPage}
                content="Siguiente"
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      );
    }
    return null;
  };

  const onChangeTaskCheckbox = (e, i, task) => {
    e.preventDefault();
    if (i.checked) {
      const newTasksObj = [...tasks.selectedTasks];
      newTasksObj.push(task);
      tasks.setSelectedTasks(newTasksObj);
    } else {
      const newArr = [...tasks.selectedTasks];
      const taskIdx = newArr.indexOf(task);
      newArr.splice(taskIdx, 1);
      tasks.setSelectedTasks(newArr);
    }
  };

  const getTaskCheckboxValue = (task) => {
    const taskSelected = tasks.selectedTasks.find((x) => x.serviceCode1 === task.serviceCode1 &&
      x.serviceCode2 === task.serviceCode2 && x.serviceCode3 === task.serviceCode3);
    return taskSelected ? true : false;
  };

  const selectAllTasks = (e, i, filteredData) => {
    e.preventDefault();
    if (i.checked) {
      const newArrObj = [...tasks.selectedTasks];
      filteredData.forEach((x) => {
        const spliceObjIdx = newArrObj.indexOf(x.original);
        spliceObjIdx === -1 && newArrObj.push(x.original);
      });
      tasks.setSelectedTasks(newArrObj);
    } else {
      const newArrObj = [...tasks.selectedTasks];
      filteredData.forEach((x) => {
        const spliceObjIdx = newArrObj.indexOf(x.original);
        spliceObjIdx !== -1 && newArrObj.splice(spliceObjIdx, 1);
      });
      tasks.setSelectedTasks(newArrObj);
    }
  };

  const getSelectAllCheckboxValue = (filteredData) => {
    let result = true;
    filteredData.forEach((x) => {
      if (tasks.selectedTasks.indexOf(x.original) === -1) {
        result = false;
      }
    });
    return result;
  };

  const onChangeEditTaskInput = (e, key, input) => {
    e.preventDefault();
    const reg = new RegExp('^[0-9]+([.][0-9]{0,2})?$');
    if (input.value && (!reg.test(input.value))) {
      return;
    }
    edit.setTaskToEdit({...edit.taskToEdit, [key]: input.value});
    edit.setLastInputChanged({'inputId': input.id, 'caretPos': e.target.selectionStart});
  };

  const renderStatusCell = (row) => {
    return (
      <div style={{'textAlign': 'center'}}>
        <Checkbox toggle checked={row.original.status === 'A' ? true : false} className='green' disabled
          onChange={(e, input) => edit.disableModelTask(e, input, row.original)} />
      </div>
    );
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    'state': {pageIndex, pageSize},
  } = useTable(
    {
      columns,
      data,
      'defaultColumn': {'Filter': DefaultColumnFilter},
      'initialState': {'pageIndex': edit.currentPage, 'pageSize': 5},
      'autoResetFilters': false,
    },
    useFilters,
    usePagination,
    (hooks) => {
      hooks.visibleColumns.push((columns) => {
        return tasks.copyTaskSection ? [
          {
            'id': 'processCheckBox',
            'width': 1,
            'Header': (row) => {
              return (
                <div style={{'textAlign': 'center'}}>
                  <Checkbox checked={getSelectAllCheckboxValue(row.filteredRows)}
                    onChange={(e, i) => selectAllTasks(e, i, row.filteredRows)} />
                </div>
              );
            },
            'Cell': ({row}) => {
              return (
                <div style={{'textAlign': 'center'}}>
                  <Checkbox checked={getTaskCheckboxValue(row.original)}
                    onChange={(e, i) => onChangeTaskCheckbox(e, i, row.original)} />
                </div>
              );
            },
          },
          ...columns.map((column, i) => {
            if (column.id === 'status') {
              return {
                ...column,
                'width': 1,
                'Cell': ({row}) => renderStatusCell(row),
                'Filter': () => null,
              };
            }
            return column;
          }),
        ] : [
          ...columns.map((column, i) => {
            if (edit.taskToEdit && (column.id === 'localFlat' || column.id === 'price')) {
              return {
                ...column,
                'Cell': (item) => {
                  return item.row.original.uniqueId === edit.taskToEdit.uniqueId ?
                    <Input fluid id={item.column.id} ref={edit.setRef}
                      onChange={(e, input) => onChangeEditTaskInput(e, item.column.id, input)}
                      value={item.column.id === 'localFlat' ? edit.taskToEdit.localFlat : edit.taskToEdit.price} /> :
                    <div>{item.value}</div>;
                },
              };
            }
            if (column.id === 'status') {
              return {
                ...column,
                'width': 1,
                'Cell': ({row}) => renderStatusCell(row),
                'Filter': () => null,
              };
            }
            return column;
          }),
          {
            'Header': '',
            'id': 'edit-col',
            'width': 1,
            'Cell': ({row}) => {
              return edit.taskToEdit && row.original.uniqueId === edit.taskToEdit.uniqueId ?
                <div className='flex middle center'>
                  <div style={{'textAlign': 'center'}}>
                    <Icon className='save' link color='green' size='big'
                      onClick={(e) => edit.editModelTask(e)} />
                  </div>
                  <div style={{'textAlign': 'center'}}>
                    <Icon className='cancel' link color='red' size='big'
                      onClick={() => edit.setTaskToEdit(null)} />
                  </div>
                </div> :
                <div style={{'textAlign': 'center'}}>
                  <Icon className='write' color='red' link size='big'
                    onClick={() => edit.setTaskToEdit(row.original)} />
                </div>;
            },
            'Filter': () => null,
          },
        ];
      });
    }
  );

  return (
    <>
      <Table className='interactive' striped {...getTableProps()} compact>
        <Table.Header>
          {headerGroups.map((headerGroup) => (
            <Table.Row key='headers' {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, index) => (
                <Table.HeaderCell
                  key={`title-${index}`}
                  textAlign='center'
                  {...column.getHeaderProps()}
                  width={column.width}
                >
                  {column.render('Header')}
                </Table.HeaderCell>
              ))}
            </Table.Row>
          ))}
          {headerGroups.map((headerGroup) => (
            <Table.Row key='filters' id='filters'>
              {headerGroup.headers.map((column, index) => (
                <Table.HeaderCell
                  key={`filter-${index}`}
                  textAlign='center'
                  width={column.width}
                >
                  {<Filter column={column} />}
                </Table.HeaderCell>
              ))}
            </Table.Row>
          ))}
        </Table.Header>
        <Table.Body {...getTableBodyProps()} style={{'maxHeight': '325px'}}>
          {!page.length && (
            <Table.Row>
              <Table.Cell colSpan={7} textAlign='center'>
                No hay datos disponibles
              </Table.Cell>
            </Table.Row>
          )}
          {page.length > 0 &&
            page.map((row, i) => {
              prepareRow(row);
              return (
                <Table.Row key={i} {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <Table.Cell width={cell.column.width} textAlign='center' {...cell.getCellProps()}>
                        {cell.render('Cell')}
                      </Table.Cell>
                    );
                  })}
                </Table.Row>
              );
            })}
        </Table.Body>
      </Table>
      <TablePaginator
        page={page}
        canPreviousPage={canPreviousPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        pageSize={pageSize}
        canNextPage={canNextPage}
        nextPage={nextPage}
        gotoPage={gotoPage}
        previousPage={previousPage}
        setPageSize={setPageSize}
      />
    </>
  );
};

export default ModelTasksTable;
